const Clock = () => {
  return (
    <svg width='16' height='15' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.2165 9.75671C10.5309 9.8615 10.8707 9.6916 10.9755 9.37724C11.0802 9.06287 10.9104 8.72308 10.596 8.61829L10.2165 9.75671ZM7.875 8.34375H7.275C7.275 8.60201 7.44026 8.83129 7.68526 8.91296L7.875 8.34375ZM8.475 4.81565C8.475 4.48428 8.20637 4.21565 7.875 4.21565C7.54363 4.21565 7.275 4.48428 7.275 4.81565H8.475ZM10.596 8.61829L8.06474 7.77454L7.68526 8.91296L10.2165 9.75671L10.596 8.61829ZM8.475 8.34375V4.81565H7.275V8.34375H8.475ZM14.025 7.5C14.025 10.8966 11.2716 13.65 7.875 13.65V14.85C11.9343 14.85 15.225 11.5593 15.225 7.5H14.025ZM7.875 13.65C4.47845 13.65 1.725 10.8966 1.725 7.5H0.525C0.525 11.5593 3.81571 14.85 7.875 14.85V13.65ZM1.725 7.5C1.725 4.10345 4.47845 1.35 7.875 1.35V0.15C3.81571 0.15 0.525 3.44071 0.525 7.5H1.725ZM7.875 1.35C11.2716 1.35 14.025 4.10345 14.025 7.5H15.225C15.225 3.44071 11.9343 0.15 7.875 0.15V1.35Z'
        fill='#6B6B6B'
      />
    </svg>
  );
};

export default Clock;
